import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { Observable } from 'rxjs/Observable';
import { Pod, Page } from '../models';
import 'rxjs/add/operator/map';
import { FirebaseService } from './firebase.service';

@Injectable()
export class PodService extends FirebaseService {
  pods: Pod[] = [];

  constructor(protected _af: AngularFire) {
    super();
    this.firebaseType = 'pods';
  }

  mapObjJson(jsonPods: any[]): Pod[] {
    let pods = jsonPods.map((pod) => new Pod(pod));
    this.pods.length = 0;
    [].push.apply(this.pods, pods);
    this.updatePodsWithPages();

    return this.pods;
  }

  getPodByUrl(firebaseUrl: string): Observable<Pod> {
    return this._af.database.object(this.firebaseRoot + '/pods' + firebaseUrl)
    .map(jsonPod => {
      jsonPod.firebaseUrl = firebaseUrl;
      let pod = new Pod(jsonPod);
      this.updatePodWithPage(pod);
      return pod;
    });
  }

  getPodObjectByUrl(firebaseUrl: string): Pod {
    let pods = this.pods.filter(pod => pod.firebaseUrl === firebaseUrl);
    if (pods.length) return pods[0];
    return null;
  }

  // Called when pages or pods are updated
  updatePodsWithPages(pages?: Page[]) {
    if (!pages) pages = this.pages;
    this.pages = pages;
    this.pods.forEach(pod => {
      this.updatePodWithPage(pod);
    });
  }

  updatePodWithPage(pod: Pod) {
    let page = this.pages.filter(page => page.id === pod.targetID);
    if (page.length) pod.targetPage = page[0];
    else pod.targetPage = null;
  }

  // should be called only on page delete as it will disable any
  // pods with a target with an id that matches the parameter Page
  // whether they still exist or not
  updatePodsWithDeletedPage(deletedPage: Page) {
    let pods = this.pods.slice();
    let firebaseList = [];
    pods.forEach(pod => {
      if (pod.targetType === 'page' && pod.targetID && pod.targetID === deletedPage.id) {
        pod.status = 'hidden';
        pod.targetPage = null;
        pod.targetID = null;
      }
      firebaseList.push(pod.toFirebaseObject());
    });

    return this._af.database.object(this.firebaseRoot).update({ pods: firebaseList });
  }

  updatePodPositions(childUrl: string, newType: string, newPosition: number) {
    let pods = this.pods.slice();
    let child = this.getPodObjectByUrl(childUrl);

    child.status = newType.toLowerCase();
    pods.splice(pods.indexOf(child), 1);
    pods.splice(newPosition, 0, child);

    let firebaseList = [];
    for (let i = 0; i < pods.length; i++) {
      firebaseList.push(pods[i].toFirebaseObject());
    }
    return this._af.database.object(this.firebaseRoot).update({ pods: firebaseList });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/pod.service.ts